import { render } from "./RequestLinkForm.vue?vue&type=template&id=ae3f1bba"
import script from "./RequestLinkForm.vue?vue&type=script&lang=js"
export * from "./RequestLinkForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__